import "./src/styles/global.css"

// NOTE: Open Sans is declared once, in gatsby-ssr.js (files in static/fonts/).
// Do NOT re-add the `@fontsource/open-sans/*.css` imports here — they declare
// the same family/weights a second time and make the fonts flicker on load.

/**
 * URL canonicalisation.
 *
 * The origin server already issues a real 301 for missing trailing slashes
 * (e.g. /about-us -> /about-us/, query string preserved), so the browser is
 * on the canonical URL by the time this runs.
 *
 * This is only a safety net for duplicate slashes. It rewrites the *pathname*
 * only, via history.replaceState:
 *   - never touches the query string or hash
 *   - never triggers a navigation, so the page does not load twice
 */
export const onClientEntry = () => {
  if (typeof window === "undefined" || !window.history?.replaceState) return

  const { pathname, search, hash } = window.location

  // Collapse duplicate slashes, then ensure a trailing slash on non-file paths.
  let cleanPath = pathname.replace(/\/{2,}/g, "/")
  if (!cleanPath.endsWith("/") && !/\.[a-z0-9]+$/i.test(cleanPath)) {
    cleanPath += "/"
  }

  if (cleanPath !== pathname) {
    window.history.replaceState(
      window.history.state,
      "",
      `${cleanPath}${search}${hash}`
    )
  }
}
